<template>
  <div class="c-winedetail">
    <v-row>
      <v-col>
        <div class="section-box">
          <div class="section-text">En quelques chiffres</div>
          <period-selector
          ></period-selector>
        </div>
      </v-col>
    </v-row>

    <v-row class="c-winedetail__items" justify="center">
      <v-col cols="2" v-for="item in counts" :key="item.label">
        <overview-item
        :src="item.src"
        :label="item.label"
        :value="item.value"
        ></overview-item>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="section-box">
          <div class="section-text">Informations sur ce vin</div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card light class="c-winedetail__infos">
          <v-container>
            <v-row>
              <v-col cols="12" md="6" class="pa-0">
                Appellation : {{ item.data.appellation }}
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Producteur : {{ producer.name }}
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Ville : {{ producer.address.city }}
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Millésime : {{ item.data.vintage }}
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Cépage : {{ item.data.grape }}
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Degré d'alcool : {{ item.data.alcohol }}°
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
              Température de service : {{ item.target_temperature }}°C
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                Pays : {{ producer.address.country }}
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row hidden-xs-only>
      <v-col>
        <div class="section-box">
          <div class="section-text">Consommation du vin</div>
        </div>

        <period-navigator>
          <wine-consumption-chart class="c-winedetail__stats"
            :chartData="history"
            :options="{responsive: true, maintainAspectRatio: false, title: {display: false}}"
            :xLabel="xLabel"
            :styles="{height: '300px', position: 'relative'}"
          ></wine-consumption-chart>
        </period-navigator>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import { BOTTLE_VOLUME } from '@/store/modules/stats';

import OverviewItem from '@/components/OverviewItem';
import PeriodNavigator from '@/components/PeriodNavigator';
import PeriodSelector from '@/components/PeriodSelector';
import WineConsumptionChart from '@/components/WineConsumptionChart';

import { dateTimeToChartLabel, periodToChartLabel } from '@/filters';

import PeriodListener from '@/mixins/PeriodListener';

import { STATS_GET_COUNT, STATS_GET_HISTORY } from '@/store/actions/stats';
import { WINE_READ } from '@/store/actions/wine';


const DEFAULT_CHART_DATA = {
  labels: [],
  datasets: [
    {
      label: 'Volume',
      borderColor: '#7addff'
    }
  ]
};

export default {
  name: 'WineDetail',

  props: {
    wineId: Number
  },

  mixins: [
    PeriodListener
  ],

  components: {
    OverviewItem,
    PeriodNavigator,
    PeriodSelector,
    WineConsumptionChart
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState({
      item: state => state.wine.wine,
      producer: state => state.producer.producer, // TODO integrate into item
      history: state => {
        const labels = [];
        const global = [];

        for (const d of state.stats.history) {
          labels.push(dateTimeToChartLabel(d.date, state.stats.period));
          global.push(d.volume / 100);
        }

        const data = Object.assign({}, DEFAULT_CHART_DATA);
        data.labels = labels;
        data.datasets[0].data = global;

        return data;
      },
      counts: state => {
        const count = state.stats.count;

        return [
          {
            label: 'Etablissements',
            src: require('@/assets/establishment_white_icon.png'),
            value: count.clients
          },
          {
            label: 'Machines',
            src: require('@/assets/machine_empty_white_icon.png'),
            value: count.machines
          },
          {
            label: 'Litres consommés',
            src: require('@/assets/L-white-icon.png'),
            value: count.volume / 100
          },
          {
            label: 'Bouteilles',
            src: require('@/assets/wine_bottle_white_icon.png'),
            value: count.volume / BOTTLE_VOLUME
          },
          {
            label: 'Verres',
            src: require('@/assets/glass_white_icon.png'),
            value: count.glasses
          },
          {
            label: 'Carafes',
            src: require('@/assets/pitcher_white_icon.png'),
            value: count.pitchers
          }
        ];
      },
      xLabel: state => {
        return periodToChartLabel(state.stats.period);
      }
    })
  },

  mounted () {
    this.fetchData();
  },

  watch: {
    'wineId': function () {
      this.fetchData();
    }
  },

  methods: {
    fetchData () {
      this.loading = true;

      axios.all([
        this.$store.dispatch(WINE_READ, this.wineId),
        this.$store.dispatch(STATS_GET_COUNT, { wine_id: this.wineId }),
        this.$store.dispatch(STATS_GET_HISTORY, { wine_id: this.wineId })
      ])
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.c-winedetail {
  &__items {
    text-align: center;
  }

  &__infos {
    background-color: lightgrey;
    color: #4a4a4a;

    &-elt {
      margin: 0 20px 0 20px;
      text-align: left;
      display: inline-block;
    }
  }
}
</style>
